import {  Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { map } from 'rxjs/operators';
import { EventsEdit } from '../_models/eventsEdit.interface';

@Injectable()
export class EventsService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions: any;
    public defaultHeaders = new HttpHeaders();
    constructor(private http: HttpClient) {

    }
    getEventsList(customer_id: string): Observable<any> {
        return this.http.get(`${this._kcmssvcURL}/configurations?customer_id=` + customer_id + `&type=EVENT`)
            .pipe(map(res => res)

            );
    }
    public getEventDetails(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getEventDetails.');
        }
        return this.http.get<EventsEdit>(`${this._kcmssvcURL}/configurations/${encodeURIComponent(String(publicId))}`);
    }

    public updateEvents(publicId: string, jsonValue: any): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling updateEvents.');
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.patch<any>(`${this._kcmssvcURL}/configurations/${encodeURIComponent(String(publicId))}`,JSON.stringify(jsonValue),{headers})           
        .pipe(map(res => res)  
         );
    }

    public updateEventsStatus(publicId: string, jsonValue: any): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling updateEventsStatus.');
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.patch<any>(`${this._kcmssvcURL}/configurations/${encodeURIComponent(String(publicId))}`,JSON.stringify(jsonValue),{headers})           
        .pipe(map(res => res)  
         );
    }
}